import "./Container.scss"

import React, { FunctionComponent } from "react"
import cx from "classnames"

export type ContainerType = "full" | "wide" | "wider" | "medium" | "regular" | "narrow" | "extranarrow"

interface IContainerProps {
    type?: ContainerType
    className?: string
}

const Container: FunctionComponent<React.PropsWithChildren<IContainerProps>> = ({
    type = "full",
    className,
    children
}) => {
    return (
        <div className={cx([
                "container",
                `container--type-${type}`,
                className
            ])}>
            {children}
        </div>
    )
}

export default Container
